<template>
	<div class="image-image" :style="style + `background-image:url(${url});`"></div>
</template>

<script>
export default {
	name: 'OImage',
	props: {
		// 图片地址
		src: {
			type: String
		},
		// 图片宽高
		wh: {
			default: '100,100'
		},
		// 传入时忽略wh参数，宽度100%
		height: {}
	},
	data() {
		return {
			defaule_img: require('@/assets/img/default_img.png'), //默认图片
			url: require('@/assets/img/default_img.png')
		};
	},
	watch: {
		src(n, o) {
			this.reloadImg();
		}
	},
	mounted() {
		this.src && this.reloadImg();
	},
	methods: {
		reloadImg() {
			let img = new Image();
			img.src = this.src;
			img.onload = e => {
				this.url = this.src;
			};
			img.onerror = e => {
				this.url = this.defaule_img;
				this.$debug && console.log('图片加载错误', e);
			};
		}
	},
	computed: {
		style() {
			if (this.height) return `height:${this.height}px;`;
			else {
				let wh = this.wh.split(',');
				return `width:${wh[0] / 100}rem;height:${wh[1] / 100}rem;`;
			}
		}
	}
};
</script>

<style scoped>
.image-image {
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	overflow: hidden;
	position: relative;
	/* transition: all 0.5s; */
}
</style>



// WEBPACK FOOTER //
// src/components/OImage.vue